export default "__VITE_ASSET__7ff4d5de__"